import { render, staticRenderFns } from "./holzpellets-preis-zusammensetzung.vue?vue&type=template&id=76a2cc75&scoped=true"
import script from "./holzpellets-preis-zusammensetzung.vue?vue&type=script&lang=ts"
export * from "./holzpellets-preis-zusammensetzung.vue?vue&type=script&lang=ts"
import style0 from "./holzpellets-preis-zusammensetzung.vue?vue&type=style&index=0&id=76a2cc75&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a2cc75",
  null
  
)

export default component.exports